const appConfig = {
    baseURL: '',
    pageTitleDefault: ' - Avance Empreendedor'
};

export default appConfig;